import { render, staticRenderFns } from "./SinusoidalFunction.component.vue?vue&type=template&id=0b17a98a&scoped=true"
import script from "./SinusoidalFunction.component.ts?vue&type=script&lang=js&external"
export * from "./SinusoidalFunction.component.ts?vue&type=script&lang=js&external"
import style0 from "./SinusoidalFunction.component.vue?vue&type=style&index=0&id=0b17a98a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b17a98a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b17a98a')) {
      api.createRecord('0b17a98a', component.options)
    } else {
      api.reload('0b17a98a', component.options)
    }
    module.hot.accept("./SinusoidalFunction.component.vue?vue&type=template&id=0b17a98a&scoped=true", function () {
      api.rerender('0b17a98a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client/iot-simulator/SinusoidalFunction.component.vue"
export default component.exports